import React from 'react';
import { SessionContext } from 'src/Views/SessionContext';
import { ContentContainer } from '../Intersystems/IntersystemsDashboard';
import IRhapsodyServer from 'src/ServerEntities/IRhapsodyServer';
import { getRhapsodyHeader, getRhapsodyServers } from '../ramService';
import IRhapsodyServerPanel from 'src/ServerEntities/IRhapsodyServerPanel';
import ErrorBox from 'src/SharedComponents/ErrorBox';
import LoadingIndicator from 'src/SharedComponents/LoadingIndicator';
import styled from 'styled-components';
import { RolesContext } from 'src/Roles/RolesContext';

const SiteContainer = styled.ul`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;
    margin-top: 20px;
`;

const TitleBar = styled.div`
    width: 1035§px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: #1577AE;
    padding: 5px;
    padding-left: 10px;
    color: #FFF;
    text-align: left;
    font-size: 1.2em;
    font-weight: bold;
`;

const OuterContainer = styled.div`
    width: 1050px;
    border-radius: 25px;
    border: 5px solid #44A2D6;
    padding: 2px;
    height: 100%;
`;

const DiskGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    padding: 16px;
    align-items: center;
`;

const StyledDiskContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const StyledDiskItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 100px;
    text-align: center;
    font-size: 14px;
    margin-top: 8px;
`;

const StatusBar = styled.div<{ percentFree: number }>`
    width: 90%;
    height: 30px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: white;
    position: relative;
    background-color: #d3d3d3;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: ${props => props.percentFree}%;
        background-color: ${props =>
            props.percentFree < 80 ? '#5CEA5A' :   
            props.percentFree < 95 ? '#FFA500' :  
            '#FF0000'
        };
        border-radius: 15px;
    }

    span {
        position: relative;
        z-index: 1;
        width: 100%;
        text-align: center;
    }
`;
interface IProps {
    selectedTypes: string[],
    changeRole: boolean,
    setChangeRole: (changeRole: boolean) => void,
};

const IntersystemsDiskUsage = (props: IProps) => {

    const { state, dispatch } = React.useContext(SessionContext);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [data, setData] = React.useState(undefined as unknown as IRhapsodyServer[]);
    const [serverPanels, setServerPanels] = React.useState(undefined as unknown as IRhapsodyServerPanel[]);
    const roleContext = React.useContext(RolesContext);
    const currentRole = roleContext.state.role;

    React.useEffect(() => {
        if (!currentRole) {
            setLoading(true);
            getRhapsodyHeader(state.webToken, (serverData: IRhapsodyServer[]) => {
                setLoading(false);
                setData(serverData);
                setError("");
                loadServers();
                dispatch({ type: "setHeaderInfo", payload: serverData });
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        }
        else {
            loadServers();
        }
    }, [state.webToken, currentRole, data]);

    const loadServers = () => {
        setLoading(true);
        getRhapsodyServers(state.webToken, (data: IRhapsodyServerPanel[]) => {
            setLoading(false);
            setServerPanels(data);
            setError("")
        }, (errorMessage: string) => {
            setLoading(false);
            setError(errorMessage);
        });
    }

    return <ContentContainer>
        <LoadingIndicator type="Linear" show={loading} />
        {error && <ErrorBox>{error}</ErrorBox>}
        <SiteContainer>
            <OuterContainer>
                <TitleBar>Disk Usage</TitleBar>
                <DiskGrid>
                    {serverPanels != undefined ? (
                        serverPanels[0].spaceMetrics
                        .sort((a, b) => a.diskId.localeCompare(b.diskId))
                        .map((disk, index) => {
                            const totalSize = (parseFloat(disk.freeGb) + parseFloat(disk.usedGb));
                            const percentUsed = parseFloat(((parseFloat(disk.usedGb) / totalSize) * 100).toFixed(1));
                            const percentFree = parseFloat(((parseFloat(disk.freeGb) / totalSize) * 100).toFixed(1));

                            return (
                                <StyledDiskContainer key={`${disk.computerName}-${disk.diskId}-${index}`}>
                                <StyledDiskItem>
                                    <strong>Disk: {disk.diskId}</strong>
                                    <strong>Size:{totalSize} GB</strong>
                                    <strong>Used:{disk.usedGb}GB</strong>
                                    <strong>{percentUsed}%</strong>
                                    <strong>Free:{disk.freeGb} GB </strong>
                                    <strong>{percentFree}%</strong>
                                </StyledDiskItem>
                                <StatusBar percentFree={percentUsed} />
                            </StyledDiskContainer>
                            );
                        })
                    ) : (
                        <ErrorBox>{error}</ErrorBox>
                    )}
                </DiskGrid>
            </OuterContainer>
        </SiteContainer>
    </ContentContainer>;

}

export default IntersystemsDiskUsage;